import { useInjection } from 'inversify-react';
import { IProfileModel } from 'models/profile/types';
import { ProfileMSDI } from 'core/profile/di/profileModelServiceTypes';

export const useProfile = () => {
  return useInjection<IProfileModel>(ProfileMSDI.ProfileModel);
};
